/**
 * El estado de un parte tal como se enseña (tarjeta de la lista y ficha):
 * Pendiente → Clasificado → En tratamiento → Resuelto, con Descartado como final.
 * Una sola regla para las dos pantallas (antes vivía solo en la lista).
 */
export type SessionDisplayStatus = "pending" | "classified" | "in_treatment" | "resolved" | "dismissed";

export interface SessionStatusFields {
  review_status?: string | null;
  triage_status?: string | null;
  linked_task_id?: string | null;
}

export function sessionStatusOf(s: SessionStatusFields): SessionDisplayStatus {
  if (s.review_status === "resolved") return "resolved";
  if (s.triage_status === "dismissed") return "dismissed";
  if (s.triage_status === "classified" && s.linked_task_id) return "in_treatment";
  if (s.triage_status === "classified") return "classified";
  return "pending";
}
